import { render, staticRenderFns } from "./HistogramMap.vue?vue&type=template&id=3e3d06fc&scoped=true&"
import script from "./HistogramMap.vue?vue&type=script&lang=js&"
export * from "./HistogramMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d06fc",
  null
  
)

export default component.exports